export default "__VITE_ASSET__CL7Nu7Gq__"